import { render } from "./AccordionSection.vue?vue&type=template&id=b3595440&scoped=true"
import script from "./AccordionSection.vue?vue&type=script&lang=js"
export * from "./AccordionSection.vue?vue&type=script&lang=js"

import "./AccordionSection.vue?vue&type=style&index=0&id=b3595440&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3595440"]])

export default __exports__